import {
    USER_DASHBOARD_BY_USER_REQUEST,
    USER_DASHBOARD_BY_USER_SUCCESS,
    USER_DASHBOARD_BY_USER_FAIL,
    USER_DASHBOARD_LIST_REQUEST,
    USER_DASHBOARD_LIST_SUCCESS,
    USER_DASHBOARD_LIST_FAIL,
    USER_DASHBOARD_LIST_RESET,
    USER_DASHBOARD_LIST_BY_IDS_REQUEST,
    USER_DASHBOARD_LIST_BY_IDS_SUCCESS,
    USER_DASHBOARD_LIST_BY_IDS_FAIL,
    USER_DASHBOARD_LIST_BY_IDS_RESET,
    USER_DASHBOARD_DETAILS_REQUEST,
    USER_DASHBOARD_DETAILS_SUCCESS,
    USER_DASHBOARD_DETAILS_FAIL,
    USER_DASHBOARD_DETAILS_RESET,
    USER_DASHBOARD_DTO_REQUEST,
    USER_DASHBOARD_DTO_SUCCESS,
    USER_DASHBOARD_DTO_FAIL,
    USER_DASHBOARD_DTO_RESET,
    USER_DASHBOARD_CREATE_REQUEST,
    USER_DASHBOARD_CREATE_SUCCESS,
    USER_DASHBOARD_CREATE_FAIL,
    USER_DASHBOARD_CREATE_RESET,
    USER_DASHBOARD_UPDATE_REQUEST,
    USER_DASHBOARD_UPDATE_SUCCESS,
    USER_DASHBOARD_UPDATE_FAIL,
    USER_DASHBOARD_UPDATE_RESET,
} from '../constants/userDashboardConstants';

export const userDashboardByUserReducer = (state = { dashboards: [] }, action) => {
    switch (action.type) {
        case USER_DASHBOARD_BY_USER_REQUEST:
            return { loading: true, dashboards: [], error: undefined };
        case USER_DASHBOARD_BY_USER_SUCCESS:
            return { loading: false, dashboards: action.payload, error: undefined };
        case USER_DASHBOARD_BY_USER_FAIL:
            return { loading: false, error: action.payload, dashboards: [] };
        default:
            return state;
    }
};

export const userDashboardListReducer = (state = { userDashboards: [] }, action) => {
    switch (action.type) {
        case USER_DASHBOARD_LIST_REQUEST:
            return { loading: true, userDashboards: [] };
        case USER_DASHBOARD_LIST_SUCCESS:
            const payload = action.payload;
            return {
                loading: false,
                userDashboards: payload.items ?? payload,
                currentPage: payload.currentPage ?? 1,
                totalPages: payload.totalPages ?? 1,
                totalCount: payload.totalCount ?? (Array.isArray(payload) ? payload.length : 0),
            };
        case USER_DASHBOARD_LIST_FAIL:
            return { loading: false, error: action.payload };
        case USER_DASHBOARD_LIST_RESET:
            return { userDashboards: [] };
        default:
            return state;
    }
};

export const userDashboardListByIdsReducer = (state = { userDashboards: [] }, action) => {
    switch (action.type) {
        case USER_DASHBOARD_LIST_BY_IDS_REQUEST:
            return { loading: true, userDashboards: [] };
        case USER_DASHBOARD_LIST_BY_IDS_SUCCESS:
            return { loading: false, userDashboards: action.payload,
            };
        case USER_DASHBOARD_LIST_BY_IDS_FAIL:
            return { loading: false, error: action.payload };
        case USER_DASHBOARD_LIST_BY_IDS_RESET:
            return { userDashboards: [] };
        default:
            return state;
    }
};

export const userDashboardDetailsReducer = (state = { userDashboard: null }, action) => {
    switch (action.type) {
        case USER_DASHBOARD_DETAILS_REQUEST:
            return { loading: true };
        case USER_DASHBOARD_DETAILS_SUCCESS:
            return { loading: false, userDashboard: action.payload };
        case USER_DASHBOARD_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case USER_DASHBOARD_DETAILS_RESET:
            return { userDashboard: null };
        default:
            return state;
    }
};

export const userDashboardDtoReducer = (state = { userDashboardDto: null }, action) => {
    switch (action.type) {
        case USER_DASHBOARD_DTO_REQUEST:
            return { loading: true, userDashboardDto: null };
        case USER_DASHBOARD_DTO_SUCCESS:
            return { loading: false, userDashboardDto: action.payload };
        case USER_DASHBOARD_DTO_FAIL:
            return { loading: false, error: action.payload };
        case USER_DASHBOARD_DTO_RESET:
            return { userDashboardDto: null };
        default:
            return state;
    }
};

export const userDashboardCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_DASHBOARD_CREATE_REQUEST:
            return { loading: true };
        case USER_DASHBOARD_CREATE_SUCCESS:
            return { loading: false, success: true, userDashboard: action.payload };
        case USER_DASHBOARD_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case USER_DASHBOARD_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const userDashboardUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_DASHBOARD_UPDATE_REQUEST:
            return { loading: true };
        case USER_DASHBOARD_UPDATE_SUCCESS:
            return { loading: false, success: true, userDashboard: action.payload };
        case USER_DASHBOARD_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case USER_DASHBOARD_UPDATE_RESET:
            return {};
        default:
            return state;
    }
};
